import * as actionTypes from "./actionTypes";
import axiosRequest from "../../axios-request/request.methods";

//bi fetched
export const fetchPreviousPolicyDetails = (payload) => {
  return {
    type: actionTypes.FETCH_PREVIOUS_POLICY_DETAILS,
    formData: payload,
  };
};
// bi started
export const editPreviousPolicyDetailsStarted = () => {
  // //console.log(formData)
  return {
    type: actionTypes.FETCH_PREVIOUS_POLICY_DETAILS_START,
  };
};

export const editPreviousPolicyDetailsSuccess = (formData, succMsg, res) => {
  return {
    type: actionTypes.FETCH_PREVIOUS_POLICY_DETAILS_SUCESS,
    formData: formData,
    succMsg: "Proposal Updated Successfully",
    response: res,
  };
};

// export const fetchPreviousPolicyDetailsSuccess = (payload, apiPath, res) => {
//   return async (dispatch) => {
//     dispatch(editPreviousPolicyDetailsStarted());
//     axiosRequest.put(apiPath, payload).then((res) => {
//       //console.log(res);

//       return dispatch(fetchPreviousPolicyDetails(res?.PreviousPolicyDetails));
//     });
//     // //console.log(req);
//   };
// };

export const fetchPreviousPolicyDetailsSuccess = (payload, apiPath) => {
  return async (dispatch) => {
    dispatch(editPreviousPolicyDetailsStarted());
    try {
      const res = await axiosRequest.put(apiPath, payload);
      dispatch(fetchPreviousPolicyDetails(res?.PreviousPolicyDetails));
      return res; // Return the response
    } catch (err) {
      // Handle errors here if needed
      console.error("Error in fetchPreviousPolicyDetailsSuccess:", err);
      throw err; // Re-throw the error to propagate it to the caller
    }
  };
};

export const editPreviousPolicyDetailsFail = (errMsg) => {
  return {
    type: actionTypes.FETCH_PREVIOUS_POLICY_DETAILS_FAIL,
    error: errMsg,
  };
};
